import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsAndConditions = () => (
  <>
    <Helmet>
      <title>Terms and Conditions | nautdigital</title>
      <meta name="description" content="Read the terms and conditions for using nautdigital's website and services." />
    </Helmet>
    <div className="container mx-auto py-16 px-4 min-h-screen">
      <h1 className="text-3xl font-bold text-white mb-6">Terms and Conditions</h1>
      <p className="text-gray-300 mb-4">
        Welcome to nautdigital. These Terms and Conditions govern your use of our website and services. By accessing or using our website, you agree to be bound by these terms.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">1. Use of Our Website</h2>
      <p className="text-gray-300 mb-4">
        You agree to use our website only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the website. Prohibited behavior includes harassing or causing distress or inconvenience to any person, transmitting obscene or offensive content, or disrupting the normal flow of dialogue within our website.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">2. Intellectual Property Rights</h2>
      <p className="text-gray-300 mb-4">
        All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of nautdigital or its content suppliers and is protected by international copyright laws. You may not reproduce, distribute, or create derivative works from our content without explicit written permission.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">3. Services</h2>
      <p className="text-gray-300 mb-4">
        nautdigital provides software development, consulting, and technical assessment services. Specific terms for individual projects or services will be outlined in separate agreements or statements of work. These Terms and Conditions apply in conjunction with any such agreements.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">4. User Content and Submissions</h2>
      <p className="text-gray-300 mb-4">
        If you submit information, feedback, or content to us through our website or contact forms, you grant nautdigital a non-exclusive, royalty-free, perpetual, and worldwide license to use, reproduce, modify, and distribute such content for business purposes. You warrant that you own or have the necessary rights to any content you submit.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">5. Limitation of Liability</h2>
      <p className="text-gray-300 mb-4">
        nautdigital shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use our website or services. This includes, but is not limited to, damages for loss of profits, data, or other intangible losses.
      </p>
      <p className="text-gray-300 mb-4">
        We do not warrant that our website will be uninterrupted, secure, or error-free, or that defects will be corrected. We make no warranties regarding the accuracy, reliability, or completeness of content on our website.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">6. Third-Party Links</h2>
      <p className="text-gray-300 mb-4">
        Our website may contain links to third-party websites or services that are not owned or controlled by nautdigital. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party websites. You acknowledge and agree that nautdigital shall not be liable for any damage or loss caused by your use of any third-party content or services.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">7. Indemnification</h2>
      <p className="text-gray-300 mb-4">
        You agree to indemnify and hold nautdigital harmless from any claims, damages, losses, liabilities, and expenses (including legal fees) arising out of your use of our website, your violation of these Terms and Conditions, or your violation of any rights of another party.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">8. Changes to Terms</h2>
      <p className="text-gray-300 mb-4">
        We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting to this page. Your continued use of the website after any changes constitutes your acceptance of the new terms.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">9. Governing Law</h2>
      <p className="text-gray-300 mb-4">
        These Terms and Conditions shall be governed by and construed in accordance with the laws of England and Wales. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of England and Wales.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">10. Severability</h2>
      <p className="text-gray-300 mb-4">
        If any provision of these Terms and Conditions is found to be invalid or unenforceable by a court of law, the remaining provisions shall continue in full force and effect.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">Contact Us</h2>
      <p className="text-gray-300 mb-2">
        If you have any questions about these Terms and Conditions, please contact us using the <a href="/contact#contact" className="text-accent hover:underline">Contact Page</a>.
      </p>
      <p className="text-gray-300">nautdigital, London, UK</p>
      <p className="text-gray-500 text-xs mt-8">Last updated: {new Date().toLocaleDateString()}</p>
    </div>
  </>
);

export default TermsAndConditions;
